import { render, staticRenderFns } from "./contest-lottery.vue?vue&type=template&id=5188c401&scoped=true"
import script from "./contest-lottery.vue?vue&type=script&lang=js"
export * from "./contest-lottery.vue?vue&type=script&lang=js"
import style0 from "./contest-lottery.vue?vue&type=style&index=0&id=5188c401&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188c401",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5188c401')) {
      api.createRecord('5188c401', component.options)
    } else {
      api.reload('5188c401', component.options)
    }
    module.hot.accept("./contest-lottery.vue?vue&type=template&id=5188c401&scoped=true", function () {
      api.rerender('5188c401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/contest-lottery.vue"
export default component.exports